// extracted by mini-css-extract-plugin
export default {"container":"GamePage_container__af853","unityContainer":"GamePage_unityContainer__7G5xD","popupContainer":"GamePage_popupContainer__A3uxe"};